<template>
  <div class="text-menu sticky-menu">
    <ul class="nav nav-justified nav-tabs nav-tabs-custom">
      <template v-for="(navChoice, index) in newNavChoice">
        <li
          v-if="
            hidderComponent(navChoice.service, (isService = true)) &&
            hidderComponent(navChoice.scope, (isService = false))
          "
          :key="index"
          class="nav-item"
        >
          <a
            :class="{ active: navChoice.active, 'ml-n3': index !== 0, 'nav-link': true }"
            aria-current="page"
            @click="setNavChoice(index)"
            >{{ navChoice.text }}</a
          >
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { hidderComponent } from '@/state/helpers'

export default {
  name: 'plaintext',
  props: {
    navChoices: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      newNavChoice: [],
    }
  },
  mounted() {
    this.newNavChoice = this.navChoices
    if (this.$route.query.actualNav) {
      this.$emit('input', this.$route.query.actualNav)
      const navIndex = this.newNavChoice.findIndex((navChoice) => navChoice.link === this.$route.query.actualNav)
      this.newNavChoice[navIndex].active = true
    } else {
      this.newNavChoice[0].active = true
      this.$emit('input', this.newNavChoice[0].link)
    }
  },

  methods: {
    hidderComponent,
    setNavChoice(index) {
      for (let i = 0; i < this.newNavChoice.length; i++) {
        if (this.newNavChoice[i].active === true) {
          this.newNavChoice[i].active = false
        }
      }
      this.newNavChoice[index].active = true
      const query = { ...this.$route.query }
      query.actualNav = this.newNavChoice[index].link
      this.$router.replace({ query })
      this.$emit('input', this.newNavChoice[index].link)
    },
  },
}
</script>

<style scoped lang="scss">
.text-menu {
  overflow: auto;
  width: 100% !important;

  ul {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    padding-bottom: 5px;
  }
  .nav-tabs .nav-item.show .nav-link {
    color: #495057;
    background-color: #eff2f7;
    border-color: #ced4da #ced4da #fff;
  }

  a {
    color: #495057;
  }

  .nav-tabs .nav-link.active {
    background-color: rgba(255, 255, 255, 0.001);
  }

  li {
    min-width: 200px;
    cursor: pointer;
  }
}
.sticky-menu {
  position: sticky;
  top: 0;
  background-color: #f8f8fb;
  transform: translateY(-10px);
  z-index: 1000;
}
</style>
